import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import SectionHeading from "./SectionHeading";

const FAQS = [
    {
        q: "I've never done this kind of work before — is it safe?",
        a: "Yes. Every session is held with care, paced by your nervous system. We begin slowly with an intake conversation, and you choose what you're ready for at every step. Nothing is forced — only invited.",
    },
    {
        q: "Are sessions online or in person?",
        a: "Most sessions are offered online and feel just as held as in-person work. Select sessions (sound healing, breathwork circles) are available in person on request. Online sessions are available worldwide.",
    },
    {
        q: "Do I need to choose a specific modality before booking?",
        a: "Not at all. If you're unsure, choose 'Discovery Call' when booking. Shreya will listen to where you are and gently suggest the right starting point — there's no pressure, only fit.",
    },
    {
        q: "How long does healing take?",
        a: "Healing isn't linear. Some patterns shift in a single session; deeper, ancestral, or trauma-rooted work usually unfolds across a multi-session container. We pace it together — never rushing what asks to be slow.",
    },
    {
        q: "Is this a replacement for therapy or medical care?",
        a: "No. Soul Sync Healing offerings are complementary and do not replace medical, psychiatric, or psychological treatment. If you're in active mental health care, this work can sit beautifully alongside it — we'll discuss this in your intake.",
    },
    {
        q: "How do I pay and confirm?",
        a: "After your inquiry, Shreya personally responds with format, timing, and gentle next steps — including payment details. There's no upfront pressure to commit; we make sure it's the right fit first.",
    },
    {
        q: "Can I cancel or reschedule?",
        a: "Yes. Life moves. We ask for at least 24 hours notice when possible so the time can be re-offered. Healing should never feel rigid.",
    },
];

export default function FAQSection() {
    return (
        <section
            className="bg-white border-t border-[#EFEBE4]"
            data-testid="faq-section"
        >
            <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
                <div className="ssh-reveal">
                    <SectionHeading
                        eyebrow="Common questions"
                        title="Soft answers to"
                        titleItalic="quiet curiosities."
                        sub="The questions people often hold before reaching out — answered with care."
                    />
                </div>
                <div className="mt-12 ssh-reveal">
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                className="border-b border-[#EFEBE4]"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-[#2C2B29] hover:text-[#A68A6B] hover:no-underline py-6 [&[data-state=open]]:text-[#A68A6B]">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-base leading-relaxed text-[#4A4947] pb-6 max-w-3xl">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
